import { useParams } from 'react-router-dom';

import useAccount from '@features/Account/store/useAccount';
import { ResourceScope } from '@app-types/blackroom-app';

/**
 * Non-admin users with manageResources can't manage permissions,
 * so uploading at root would create files they can't access.
 * Only allow resource management inside folders where they inherit permissions.
 */
function useCanManageResources() {
  const { isCurrentWorkspaceAdmin, hasPermission } = useAccount();
  const { folderId } = useParams<{ scope: ResourceScope; folderId?: string }>();

  const isAtRoot = !folderId;
  const canManageResourcesHere =
    isCurrentWorkspaceAdmin || (hasPermission('manageResources') && !isAtRoot);

  return { canManageResourcesHere, isAtRoot };
}

export default useCanManageResources;
